import { Header } from '@rbilabs/universal-components';

const SectionHeading = Header.withConfig({
  variant: 'headerTwo',
  color: Styles.color.black,
  fontSize: 'xl',
  marginTop: '$5',
  marginBottom: '$3',
  focusable: true,
});

export default SectionHeading;
